import React from "react";
import { autobind } from "react-decoration";
import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import ReactLoading from "react-loading";
import gql from "graphql-tag";

const getHoldStatusItemList = gql`
  query getHoldStatusItemList($searchForm: HoldStatusSearchForm) {
    getHoldStatusItemList(Input: $searchForm) {
      num
      callnumber
      location
      barcode
      publicNote
      canReserve
      holdID
      available
    }
  }
`;

class HoldStatusItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  @autobind
  toggleAccordion(e) {
    e.persist();
    e.target.classList.toggle("turnicon");    
    let turnicon = e.target.classList.contains("turnicon") ? "":"none";
    this.tableList.style.display = turnicon;    
  }
  render() {
    let { t ,brn,issn,db} = this.props;
    if (
      (!this.props.brn || this.props.brn === "") &&
      (!this.props.issn || this.props.issn === "")
    ) {
      return <></>;
    }
    return (
      <>
        <ApolloProvider client={client.jumperrwdClient}>
          <Query
            query={getHoldStatusItemList}
            fetchPolicy="network-only"
            variables={{
              searchForm: {
                issn: this.props.issn,
                brn: this.props.brn,
                dbid: this.props.db
              },
            }}>
            {({ loading, error, data, refetch }) => {
              if (loading)
                return (
                  <center>
                    <ReactLoading
                      type="cylon"
                      height={"10%"}
                      width={"20%"}
                      color="#005D98"
                    />
                  </center>
                );
              if (error) return `Error!${error.message}`;
              if (data && data.getHoldStatusItemList) {
                let itemList = data.getHoldStatusItemList;
                let out = [];
                out.push(<></>);
                let aviableCnt = 0;
                itemList.map((item) => {
                  let {
                    num,
                    callnumber,
                    location,
                    barcode,
                    publicNote,
                    canReserve,
                    holdID,
                    available,
                  } = item;
                  aviableCnt += available;
                  out.push(
                    <tr>
                      <td>{num}</td>
                      <td>{callnumber}</td>
                      <td>{location}</td>
                      <td>{barcode}</td>
                      <td>{publicNote}</td>
                    </tr>
                  );
                });
                if (out.length > 0) {
                  return (
                    <>
                      <div className="status">
                        <button
                          type="button"
                          tabIndex="0"
                          onClick={this.toggleAccordion.bind(this)}
                          className={"popover"}>
                          {t("jumper.common.status")}
                        </button>
                        {aviableCnt > 0 && (
                          <span className="tip">
                            {t("jumper.common.available.borrow")}
                          </span>
                        )}
                      </div>
                      <div
                        className="popover_content table_list"
                        ref={(c) => {
                          this.tableList = c;
                        }}
                        style={{ display: "none" }}>
                        <table>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>{t("jumper.common.callnumber")}</th>
                              <th>{t("jumper.common.locations")}</th>
                              <th>{t("jumper.common.barcode")}</th>
                              <th>{t("jumper.common.status")}</th>
                            </tr>
                          </thead>
                          <tbody>{out}</tbody>
                        </table>
                      </div>
                    </>
                  );
                }
                return "";
              }
              return "";
            }}
          </Query>
        </ApolloProvider>
      </>
    );
  }
}

export default HoldStatusItem;
